import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
import AssociatedClasses from "./routes/AssociatedClasses";
import StaffMembers from "./routes/StaffMembers";
import GradingConfigurations from "./routes/GradingConfigurations";
import GradingVisibility from "./routes/GradingVisibility";
import SyncHistory from "./routes/SyncHistory";
import AssociatedCourses from "./routes/AssociatedCourses";
import NavigationSettings from "./routes/NavigationSettings";

export default store => ({
  path: "course-settings",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "course-settings" */ "./components"),
      import(
        /* webpackChunkName: "course-settings" */ "./modules/CourseSettingsModule"
      ),
      import(
        /* webpackChunkName: "course-settings" */ "SchoolSetup/modules/SchoolSetupModule"
      ),
      import(
        /* webpackChunkName: "course-settings" */ "CourseSetup/modules/Module"
      ),
    ]).then(
      ([importedModule0, importedModule1, importedModule2, importModule3]) => {
        const component = importedModule0.default;
        const courseSettingsReducer = importedModule1.default;
        const schoolSetupReducer = importedModule2.default;
        const courseSetupReducer = importModule3.default;
        injectReducer(store, {
          key: "courseSettings",
          reducer: courseSettingsReducer,
        });
        injectReducer(store, {
          key: "schoolSetup",
          reducer: schoolSetupReducer,
        });
        injectReducer(store, {
          key: importModule3.NAME,
          reducer: courseSetupReducer,
        });
        return component;
      }
    )
  ),
  childRoutes: [
    NavigationSettings(store),
    AssociatedClasses(store),
    AssociatedCourses(store),
    StaffMembers(store),
    GradingConfigurations(store),
    GradingVisibility(store),
    SyncHistory(store),
  ],
});
